import { useCallback, useEffect, useState } from "react";

export default function useLoadingPercentage(updateTime, expectedDuration = 14, isSuccessful, isFailed) {
  const getLoadingPercentage = useCallback(
    (updateTime) => {
      if (!updateTime) return 0;

      const scaleParameter = expectedDuration / 2;
      const shiftParameter = Math.max(expectedDuration / 4 - 1, 0);

      const updateDate = new Date(updateTime);
      if (isNaN(updateDate.getTime())) return 0;

      const timeElapsedMs = Date.now() - updateDate.getTime();
      const timeElapsedMin = timeElapsedMs / 1000 / 60;

      const iLogitParameter = timeElapsedMin / scaleParameter - shiftParameter;
      const iLogitExponential = Math.exp(iLogitParameter);
      const percentage = iLogitExponential / (1 + iLogitExponential);
      const result = Math.round(percentage * 100);

      return isNaN(result) ? 0 : result;
    },
    [expectedDuration]
  );

  const [progress, setProgress] = useState(() =>
    getLoadingPercentage(updateTime, expectedDuration)
  );

  const [loadingValue, setLoadingValue] = useState(
    isSuccessful || isFailed ? 100 : progress
  );

  const [loadingText, setLoadingText] = useState(`${loadingValue}%`);

  useEffect(() => {
    const update = () => setProgress(getLoadingPercentage(updateTime, expectedDuration));
    update(); // run immediately once
    const interval = setInterval(update, 10 * 1000);
    return () => clearInterval(interval);
  }, [updateTime, getLoadingPercentage]); 

  useEffect(() => {
    const lv = isSuccessful ? 100 : progress;
    const clamped = Math.max(0, Math.min(100, lv));
    setLoadingValue(clamped);
    setLoadingText(`${clamped}%`);
  }, [progress, isSuccessful, isFailed]);

  return { loadingValue, loadingText };
}
